import { useEffect, type RefObject } from "react";

import type VectorSource from "ol/source/Vector";
import { addObservationMarker } from "../helpers";
import { IImageryState } from "../types/map-type";
import { DataWeatherStation } from "@/schemas/observation-schema";

export const useMapObservationMarker = ({
	observationSourceRef,
	imageryState,
	activeFilter,
}: {
	activeFilter?: keyof DataWeatherStation;
	observationSourceRef: RefObject<VectorSource | null>;
	imageryState?: IImageryState;
}) => {
	useEffect(() => {
		if (!observationSourceRef.current) return;

		if (!imageryState?.showStation) {
			observationSourceRef.current.clear();
			return;
		}

		if (!imageryState.observationData) return;

		observationSourceRef.current.clear();

		const markers = addObservationMarker({
			mergedObsData: imageryState.observationData,
			currentIndex: imageryState.currentIndex,
			filter: activeFilter,
		});

		observationSourceRef.current.addFeatures(markers);
	}, [
		imageryState?.observationData,
		imageryState?.showStation,
		imageryState?.currentIndex,
		activeFilter,
	]);
};
